import { render, staticRenderFns } from "./NolaNovelData.vue?vue&type=template&id=37428500&scoped=true"
import script from "./NolaNovelData.vue?vue&type=script&lang=ts"
export * from "./NolaNovelData.vue?vue&type=script&lang=ts"
import style0 from "./NolaNovelData.vue?vue&type=style&index=0&id=37428500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37428500",
  null
  
)

export default component.exports